import * as React from "react";

interface AccessibilityCheckerIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

const AccessibilityCheckerIcon: React.FC<AccessibilityCheckerIconProps> = ({
  width = 40,
  height = 40,
  className = "",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 103 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g filter="url(#filter0_d_1117_3298)">
      {/* Main Circle Background */}
      <path
        d="M51.3335 19.6667C66.2452 19.6667 78.3335 31.7551 78.3335 46.6667C78.3335 61.5784 66.2452 73.6667 51.3335 73.6667C36.4218 73.6667 24.3335 61.5784 24.3335 46.6667C24.3335 31.7551 36.4218 19.6667 51.3335 19.6667Z"
        fill="#0B66E4"
        stroke="#B3D0F7"
        strokeWidth={2}
      />
      
      {/* Accessibility Person Icon */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.6753 49.6931C50.5789 49.9191 49.2847 54.9603 49.2847 54.9603C49.2547 55.0732 49.2033 55.179 49.133 55.2716C49.0628 55.3642 48.9753 55.442 48.8755 55.5003C48.6739 55.618 48.4344 55.6498 48.2097 55.5884C48.0986 55.5581 47.9943 55.5058 47.903 55.4344C47.8117 55.3632 47.7351 55.2744 47.6777 55.1732C47.5615 54.9686 47.5302 54.7256 47.5907 54.4977C47.5907 54.4977 49.1339 49.4671 49.1339 48.3941V45.7801L45.7004 44.8458C45.5875 44.8173 45.4813 44.7662 45.388 44.6956C45.2947 44.6249 45.2162 44.5362 45.1572 44.4345C45.098 44.3327 45.0595 44.2201 45.0437 44.1031C45.028 43.986 45.0353 43.867 45.0654 43.7529C45.0953 43.6389 45.1474 43.5319 45.2186 43.4385C45.2898 43.345 45.3786 43.267 45.4798 43.2086C45.581 43.1503 45.6927 43.1131 45.8082 43.0991C45.9237 43.0851 46.0409 43.0945 46.1528 43.1269C46.1528 43.1269 49.0533 44.1287 50.1861 44.1287H52.4815C53.6126 44.1287 56.5113 43.1269 56.5113 43.1269C56.7359 43.0655 56.9754 43.0972 57.177 43.215C57.3786 43.3328 57.5257 43.5271 57.5863 43.755C57.6467 43.983 57.6154 44.2259 57.4993 44.4305C57.3832 44.6351 57.1919 44.7844 56.9672 44.8458L53.5196 45.7836V48.3941C53.5196 49.4671 55.0628 54.4923 55.0628 54.4923C55.123 54.7202 55.0916 54.9631 54.9753 55.1676C54.859 55.3719 54.6675 55.5212 54.4429 55.5822C54.2183 55.6433 53.9789 55.6113 53.7775 55.4935C53.576 55.3755 53.429 55.1811 53.3688 54.9532C53.3688 54.9532 52.0694 49.9191 51.98 49.6931C51.8923 49.4671 51.596 49.4671 51.596 49.4671H51.0576C51.0576 49.4671 50.7542 49.4671 50.6753 49.6931ZM51.3329 42.7887C51.8561 42.7887 52.3579 42.5778 52.7279 42.2024C53.0979 41.827 53.3057 41.3178 53.3057 40.7868C53.3057 40.256 53.0979 39.7467 52.7279 39.3713C52.3579 38.9959 51.8561 38.7849 51.3329 38.7849C50.8097 38.7849 50.3079 38.9959 49.9379 39.3713C49.5679 39.7467 49.3601 40.256 49.3601 40.7868C49.3601 41.3178 49.5679 41.827 49.9379 42.2024C50.3079 42.5778 50.8097 42.7887 51.3329 42.7887Z"
        fill="white"
      />
      
      {/* Scanner Frame Corners */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.6091 42.2762C41.8592 42.0262 41.9997 41.687 41.9997 41.3334V38.5641C41.9997 37.9521 42.029 37.8027 42.109 37.6521C42.1553 37.5622 42.2285 37.489 42.3183 37.4427C42.4703 37.3627 42.6183 37.3334 43.2303 37.3334H45.9997C46.3533 37.3334 46.6924 37.1929 46.9425 36.9429C47.1925 36.6928 47.333 36.3537 47.333 36.0001C47.333 35.6465 47.1925 35.3073 46.9425 35.0573C46.6924 34.8072 46.3533 34.6667 45.9997 34.6667H43.2303C42.2157 34.6667 41.6503 34.7761 41.061 35.0921C40.5023 35.3894 40.0557 35.8361 39.7583 36.3947C39.4423 36.9841 39.333 37.5507 39.333 38.5641V41.3334C39.333 41.687 39.4735 42.0262 39.7235 42.2762C39.9736 42.5263 40.3127 42.6667 40.6663 42.6667C41.02 42.6667 41.3591 42.5263 41.6091 42.2762ZM46.9425 56.3906C46.6924 56.1406 46.3533 56.0001 45.9997 56.0001H43.2303C42.6183 56.0001 42.469 55.9707 42.3183 55.8907C42.225 55.8414 42.1597 55.7747 42.109 55.6814C42.029 55.5294 41.9997 55.3814 41.9997 54.7694V52.0001C41.9997 51.6465 41.8592 51.3073 41.6091 51.0573C41.3591 50.8072 41.02 50.6667 40.6663 50.6667C40.3127 50.6667 39.9736 50.8072 39.7235 51.0573C39.4735 51.3073 39.333 51.6465 39.333 52.0001V54.7694C39.333 55.7841 39.4423 56.3494 39.7583 56.9387C40.0531 57.4931 40.5067 57.9467 41.061 58.2414C41.6503 58.5574 42.217 58.6667 43.2303 58.6667H45.9997C46.3533 58.6667 46.6924 58.5263 46.9425 58.2762C47.1925 58.0262 47.333 57.687 47.333 57.3334C47.333 56.9798 47.1925 56.6407 46.9425 56.3906ZM55.7235 36.9429C55.4735 36.6928 55.333 36.3537 55.333 36.0001C55.333 35.6465 55.4735 35.3073 55.7235 35.0573C55.9736 34.8072 56.3127 34.6667 56.6663 34.6667H59.4357C60.4503 34.6667 61.0157 34.7761 61.605 35.0921C62.1593 35.3868 62.6129 35.8404 62.9077 36.3947C63.2237 36.9841 63.333 37.5507 63.333 38.5641V41.3334C63.333 41.687 63.1925 42.0262 62.9425 42.2762C62.6924 42.5263 62.3533 42.6667 61.9997 42.6667C61.646 42.6667 61.3069 42.5263 61.0569 42.2762C60.8068 42.0262 60.6663 41.687 60.6663 41.3334V38.5641C60.6663 37.9521 60.637 37.8027 60.557 37.6521C60.5077 37.5587 60.441 37.4934 60.3477 37.4427C60.1957 37.3627 60.0477 37.3334 59.4357 37.3334H56.6663C56.3127 37.3334 55.9736 37.1929 55.7235 36.9429Z"
        fill="white"
      />
      
      {/* Magnifying Glass */}
      <path
        d="M65.7772 60.0946L63.8199 58.1373M64.8752 55.5846C64.8752 57.5772 63.2599 59.1926 61.2672 59.1926C59.2745 59.1926 57.6592 57.5772 57.6592 55.5846C57.6592 53.5919 59.2745 51.9766 61.2672 51.9766C63.2599 51.9766 64.8752 53.5919 64.8752 55.5846Z"
        stroke="white"
        strokeWidth={1.52213}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1117_3298"
        x={0.000160217}
        y={0.000079155}
        width={102.667}
        height={102.667}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4.66667} />
        <feGaussianBlur stdDeviation={11.6667} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1117_3298"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1117_3298"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default AccessibilityCheckerIcon;
